import { render, staticRenderFns } from "./configMarginOptions.vue?vue&type=template&id=fa713fd8&scoped=true"
import script from "./configMarginOptions.vue?vue&type=script&lang=js"
export * from "./configMarginOptions.vue?vue&type=script&lang=js"
import style0 from "./configMarginOptions.vue?vue&type=style&index=0&id=fa713fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa713fd8",
  null
  
)

export default component.exports